import React, { PureComponent } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { RenditionLoadable } from '../../../utils/general/LoadableRelated';
import { connect } from 'react-redux';
import $ from 'jquery';

interface ICorporateAccessProps {
    pop: boolean;
    source?: any;
    docHeaderSectionJson: any;
    initialData: any;
    showOldBranding?: boolean;
}

const FormPopup = RenditionLoadable({
    loader: () => import('../../../modalrelated/formPopup'),
}, "formPopup", Date.now());

export class CorporateAccess extends PureComponent<ICorporateAccessProps, any> {
    constructor(props: ICorporateAccessProps) {
        super(props);
        this.state = {
            modalStatus: this.props.pop,
            hover: false,
            disabled: false
        };
    }

    public openModal(e: any) {
        // Improtant!!! you must setState in below if else to avoid cause reRender!
        if (e.target.id === "modalClose" || e.target.getAttribute('data-btn') === 'close') { // Improtant!!! if you want close modal in more case only change this if
            this.setState({
                modalStatus: false,
            });
            $('.triggered_popup_flag').focus().removeClass('triggered_popup_flag');
        } else if (this.state.modalStatus === false) { // Improtant!!! don't change this if in any case
            this.setState({
                modalStatus: true,
            });
            e.target.className += " triggered_popup_flag";
        }
    }

    public handleMouseOver(e: any){
        this.setState({
            hover: $(e.target).closest('div#requestCorporateAccess').hasClass('deaden') ? true : false,
            disabled: $(e.target).closest('div#requestCorporateAccess').hasClass('deaden') ? true : false,
        });
    }

    public handleMouseOut(){
        this.setState({
            hover: false,
            disabled: false
        });
    }

    public handleEnterKey(e: any){
        const code = e.keyCode || e.which;
        if (code === 13 || code === 32) {
            !this.state.disabled && this.openModal(e);
        }
    }

    public render() {
        const { docHeaderSectionJson, initialData, showOldBranding } = this.props;
        const toolTipStyle = {
            visibility: this.state.hover ? 'visible' as 'visible' : 'hidden' as 'hidden',
            position: 'absolute' as 'absolute',
            background: '#e0e0e0',
            color: 'black',
            padding: '10px',
            width: '80%',
            zIndex: 1,
        };

        return (
            <div aria-disabled={this.state.disabled}
                 className="financials"
                 onClick={(e) => !this.state.disabled && this.openModal(e)}
                 onMouseOver={this.handleMouseOver.bind(this)}
                 onMouseOut={this.handleMouseOut.bind(this)}
                 onKeyPress={(e) => this.handleEnterKey(e)}
                 onFocus={this.handleMouseOver.bind(this)}
                 onBlur={this.handleMouseOut.bind(this)}
            >
                {this.state.modalStatus &&
                    <FormPopup titleSource={docHeaderSectionJson.i18n.requestCorporateAccess} typeIdentifier={'Corporate Access'} closeable={!this.props.pop}/>
                }
                {showOldBranding && <span className="icon-hands icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.requestCorporateAccess}/>}
                {!showOldBranding && <span className='icon-svg-parent'>
                    <span className="icon-svg icon-corporate-internet-svg" aria-label={docHeaderSectionJson.i18n.requestCorporateAccess} role="img"/>
                </span>}
                <a tabIndex={0} role="link" className="x-rsch-hyperlink label-corporate" aria-label={docHeaderSectionJson.i18n.requestCorporateAccess}
                   data-deque-tooltip={docHeaderSectionJson.i18n.requestCorporateAccess}>
                    {docHeaderSectionJson.i18n.requestCorporateAccess}
                </a>
                <span className="icon-padlock icon-sprite" aria-label={initialData.request_corporate_access_entitlement_message} role="img"/>
                <div style={toolTipStyle}>
                    {initialData.request_corporate_access_entitlement_message}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
    };
};

export default connect(mapStateToProps)(CorporateAccess);
